import { render } from "./MedNyttStandardPage.vue?vue&type=template&id=347dfba8"
import script from "./MedNyttStandardPage.vue?vue&type=script&lang=js"
export * from "./MedNyttStandardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__